export default {
  nav: {
    services: 'Servicios',
    process: 'Proceso',
    whyUs: 'Por qué nosotros',
    portfolio: 'Portfolio',
    about: 'Nosotros',
    contact: 'Contacto',
    getInTouch: 'Contactanos',
    goHome: 'Ir al inicio',
    language: 'Idioma',
    menu: 'Menú',
  },
  hero: {
    tagline: 'Ingeniería de software de punta a punta',
    subtitle: 'Un estudio de software en Montevideo, Uruguay. Construimos apps móviles y las plataformas que las sostienen, desde la primera versión hasta producción. Desde 2023.',
    ourServices: 'Nuestros servicios',
  },
  trustedBy: {
    title: 'Confían en nosotros',
  },
  services: {
    eyebrow: 'Soluciones principales',
    title: 'Qué construimos',
    subtitle: 'Soluciones de software integrales, adaptadas a las necesidades de tu negocio',
    items: {
      web: {
        title: 'Aplicaciones web a medida',
        description:
          'Plataformas modernas y escalables construidas con React, Next.js, TypeScript, Node.js y NestJS.',
        tags: ['React', 'Next.js', 'TypeScript', 'Node.js'],
      },
      mobile: {
        title: 'Aplicaciones móviles',
        description: 'Apps multiplataforma de alto rendimiento con React Native.',
        tags: ['React Native', 'iOS', 'Android', 'Multiplataforma'],
      },
      integrations: {
        title: 'Integraciones de APIs y sistemas',
        description:
          'Integraciones seguras con sistemas de pago, CRM, logística, ticketing y servicios basados en IA.',
        tags: ['Sistemas de pago', 'CRM', 'Logística', 'Servicios de IA'],
      },
    },
  },
  whyUs: {
    title: 'Por qué trabajar con Ventura Software',
    items: {
      bilingual: {
        title: 'Trabajamos en español e inglés',
        description:
          'Reuniones, documentación y comunicación diaria en el idioma que prefiera tu equipo.',
      },
      meet: {
        title: 'Conocé a tu desarrollador',
        description:
          'Los clientes pueden conocer y entrevistar al ingeniero asignado para confirmar el encaje técnico y cultural.',
      },
      support: {
        title: 'Soporte confiable',
        description:
          'Ofrecemos capacidad de ingeniería constante, con PM y QA opcionales cuando se necesitan.',
      },
      rotation: {
        title: 'Baja rotación',
        description:
          'Un equipo estable a largo plazo que reduce el costo de onboarding y garantiza continuidad.',
      },
    },
  },
  process: {
    eyebrow: 'Nuestro proceso',
    title: 'Desarrollo de punta a punta',
    subtitle: 'Cómo pasa un proyecto de la primera llamada a producción.',
    step: 'Paso {{number}}',
    steps: {
      discovery: {
        title: 'Descubrimiento',
        description:
          'Relevamiento de requerimientos, investigación de mercado y planificación estratégica para alinear objetivos.',
      },
      design: {
        title: 'Diseño UI/UX',
        description:
          'Wireframes, prototipos interactivos y sistemas de diseño completos.',
      },
      development: {
        title: 'Desarrollo',
        description:
          'Sprints ágiles con revisiones de código, tests automatizados e integración continua.',
      },
      qa: {
        title: 'QA y testing',
        description:
          'Testing integral: tests automatizados, QA manual y optimización de rendimiento.',
      },
      launch: {
        title: 'Lanzamiento',
        description:
          'Despliegue a producción, configuración de monitoreo y optimización de rendimiento.',
      },
      support: {
        title: 'Soporte y crecimiento',
        description:
          'Mantenimiento continuo, nuevas funcionalidades y escalado a medida que tu negocio crece.',
      },
    },
  },
  about: {
    eyebrow: 'Sobre Ventura Software',
    titleLine1: 'Excelencia en ingeniería',
    titleLine2: 'desde Uruguay',
    body:
      'Ventura Software es un estudio boutique de ingeniería enfocado en entregar productos digitales confiables, escalables y de alta calidad. Ayudamos a las empresas a ampliar y fortalecer sus capacidades de producto con experiencia de ingeniería senior.',
  },
  contact: {
    title: 'Contanos qué necesitás. Respondemos en menos de 24 horas.',
    body: 'Agendá una llamada de 30 minutos, escribinos por email o por WhatsApp. O usá el formulario.',
    email: 'Email',
    phone: 'Teléfono',
    location: 'Ubicación',
    bookCall: 'Agendá una llamada de 30 min',
    privacyNotice: 'Usamos tus datos solo para responderte. El formulario se envía a través de EmailJS.',
    privacyLink: 'Política de privacidad',
    form: {
      name: 'Nombre',
      namePlaceholder: 'Juan Pérez',
      email: 'Email',
      emailPlaceholder: 'juan@empresa.com',
      message: 'Mensaje',
      messagePlaceholder: 'Contanos sobre tu proyecto...',
      maxChars: 'Máximo 500 caracteres',
      submit: 'Iniciar una conversación',
      sending: 'Enviando...',
      success:
        '¡Gracias! Tu mensaje se envió correctamente. Te responderemos a la brevedad.',
      error: '¡Ups! Algo salió mal. Por favor, intentalo de nuevo más tarde.',
    },
  },
  footer: {
    tagline: 'Construimos productos digitales excepcionales con equipos de ingeniería senior.',
    quickLinks: 'Enlaces rápidos',
    getInTouch: 'Contacto',
    rights: '© {{year}} Ventura Software. Todos los derechos reservados.',
  },
  notFound: {
    title: 'Esta página no existe',
    body: 'Es posible que la página que buscás se haya movido o eliminado.',
    backHome: 'Volver al inicio',
  },
};
